/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DeviceStatusSrmConnector } from "./DeviceStatusSrmConnector";
import {
    DeviceStatusSrmConnectorFromJSON,
    DeviceStatusSrmConnectorFromJSONTyped,
    DeviceStatusSrmConnectorToJSON,
} from "./DeviceStatusSrmConnector";

/**
 * Objects of type DeviceStatusSrm are sent to hub method named deviceStatusNotification in the device group device_<deviceId>. Srm == SignalR Message. Listen to it via `signalRHub.on('deviceStatusNotification', (message: DeviceStatusSrm) => {}`
 * @export
 * @interface DeviceStatusSrm
 */
export interface DeviceStatusSrm {
    /**
     *
     * @type {string}
     * @memberof DeviceStatusSrm
     */
    deviceId?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceStatusSrm
     */
    deviceType?: DeviceStatusSrmDeviceTypeEnum;
    /**
     * Device.Status
     * @type {string}
     * @memberof DeviceStatusSrm
     */
    status?: string;
    /**
     * Device.SimpleDeviceStatus
     * @type {string}
     * @memberof DeviceStatusSrm
     */
    simpleDeviceState?: DeviceStatusSrmSimpleDeviceStateEnum;
    /**
     * The index of the connector (or device if 0) that triggered this message
     * @type {number}
     * @memberof DeviceStatusSrm
     */
    connectorIndex?: number;
    /**
     *
     * @type {Date}
     * @memberof DeviceStatusSrm
     */
    timestamp?: Date;
    /**
     * The source of this event. One of:
     * DeviceStatus, ConnectorStatus, StartTransaction, StopTransaction, Online, Offline
     * @type {string}
     * @memberof DeviceStatusSrm
     */
    trigger?: string;
    /**
     *
     * @type {boolean}
     * @memberof DeviceStatusSrm
     */
    isOnline?: boolean;
    /**
     * Any extra key-value info we want to push to frontend
     * @type {{ [key: string]: string; }}
     * @memberof DeviceStatusSrm
     */
    extras?: { [key: string]: string };
    /**
     *
     * @type {Array<DeviceStatusSrmConnector>}
     * @memberof DeviceStatusSrm
     */
    connectors?: Array<DeviceStatusSrmConnector>;
}

/**
 * @export
 */
export const DeviceStatusSrmDeviceTypeEnum = {
    ChargePoint: "ChargePoint",
    Illuminate: "Illuminate",
    ThirdPartyPassthrough: "ThirdPartyPassthrough",
    PayMate: "PayMate",
    Wave: "Wave",
    PowerMeter: "PowerMeter",
    Core: "Core",
    Barrier: "Barrier",
} as const;
export type DeviceStatusSrmDeviceTypeEnum =
    (typeof DeviceStatusSrmDeviceTypeEnum)[keyof typeof DeviceStatusSrmDeviceTypeEnum];

/**
 * @export
 */
export const DeviceStatusSrmSimpleDeviceStateEnum = {
    Unknown: "Unknown",
    Available: "Available",
    InUse: "InUse",
    Faulted: "Faulted",
    Raised: "Raised",
    Lowered: "Lowered",
    NoCurtailment: "NoCurtailment",
    LightCurtailment: "LightCurtailment",
    HeavyCurtailment: "HeavyCurtailment",
} as const;
export type DeviceStatusSrmSimpleDeviceStateEnum =
    (typeof DeviceStatusSrmSimpleDeviceStateEnum)[keyof typeof DeviceStatusSrmSimpleDeviceStateEnum];

/**
 * Check if a given object implements the DeviceStatusSrm interface.
 */
export function instanceOfDeviceStatusSrm(
    value: object,
): value is DeviceStatusSrm {
    return true;
}

export function DeviceStatusSrmFromJSON(json: any): DeviceStatusSrm {
    return DeviceStatusSrmFromJSONTyped(json, false);
}

export function DeviceStatusSrmFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceStatusSrm {
    if (json == null) {
        return json;
    }
    return {
        deviceId: json["deviceId"] == null ? undefined : json["deviceId"],
        deviceType: json["deviceType"] == null ? undefined : json["deviceType"],
        status: json["status"] == null ? undefined : json["status"],
        simpleDeviceState:
            json["simpleDeviceState"] == null
                ? undefined
                : json["simpleDeviceState"],
        connectorIndex:
            json["connectorIndex"] == null ? undefined : json["connectorIndex"],
        timestamp:
            json["timestamp"] == null ? undefined : new Date(json["timestamp"]),
        trigger: json["trigger"] == null ? undefined : json["trigger"],
        isOnline: json["isOnline"] == null ? undefined : json["isOnline"],
        extras: json["extras"] == null ? undefined : json["extras"],
        connectors:
            json["connectors"] == null
                ? undefined
                : (json["connectors"] as Array<any>).map(
                      DeviceStatusSrmConnectorFromJSON,
                  ),
    };
}

export function DeviceStatusSrmToJSON(value?: DeviceStatusSrm | null): any {
    if (value == null) {
        return value;
    }
    return {
        deviceId: value["deviceId"],
        deviceType: value["deviceType"],
        status: value["status"],
        simpleDeviceState: value["simpleDeviceState"],
        connectorIndex: value["connectorIndex"],
        timestamp:
            value["timestamp"] == null
                ? undefined
                : value["timestamp"].toISOString(),
        trigger: value["trigger"],
        isOnline: value["isOnline"],
        extras: value["extras"],
        connectors:
            value["connectors"] == null
                ? undefined
                : (value["connectors"] as Array<any>).map(
                      DeviceStatusSrmConnectorToJSON,
                  ),
    };
}
